import { createSelector } from 'reselect';

const getStylistTool = function(state) {
  return state.stylistTool;
}

const getRanges = state => ({
  ...state.rangeHairCare,
  ...state.rangeHairColor,
  ...state.rangeMakeUp,
  ...state.rangeMens,
  ...state.rangePerm,
  ...state.rangeSkinBodyCare,
  ...state.rangeStyling,
});

/* eslint-disable */

const getDeveloperRangesIds = createSelector([getStylistTool], (stylistTool) => stylistTool.developerRanges);
const getColorRangesIds = createSelector([getStylistTool], (stylistTool) => stylistTool.colorRanges);

export const getDeveloperRanges = createSelector([getRanges, getDeveloperRangesIds], (ranges, ids) => ranges && ids ? ids.map(id => ranges[id]) : []);
export const getColorRanges = createSelector([getRanges, getColorRangesIds], (ranges, ids) => ranges && ids ? ids.map(id => ranges[id]) : []);



// WEBPACK FOOTER //
// ./src/redux/selectors/stylistTool.js